const pageUrls = {
  loginPage: '/',
  usersPage: '/UserAdminPage',
  zipCodesPage: '/ZipCodesPage',
  digitizePage: '/DigitizePage',
  enhancePage: '/EnhancePage',
  rushesPage: '/RushesPage',
  giftCardPage: '/GiftCardPage',
  permissionsPage: '/PermissionsPage',
  createPage: '/CreatePage',
  deliveriesPage: '/DeliveriesPage',
  helpCenterPage: '/HelpCenterPage',
  collectionsPage: '/CollectionsPage',
  blogsPage: '/BlogsPage',
  articleEditorPage: '/ArticlePage/editor',
  promotionsPage: '/PromotionsPage',
  settingsPage: '/SettingsPage',
  pagesContent: '/PagesContent',
  companiesPage: '/pod',
  albumsPage: '/AlbumsPage',
  errorLogsPage: '/ErrorLogsPage',
  // Analytics
  analyticsDashboard: '/analytics',
  sessionsList: '/analytics/sessions',
  sessionPlayer: '/analytics/sessions/:id',
  heatmapsPage: '/analytics/heatmaps',
  frontendErrorsPage: '/analytics/frontend-errors',
  alertsPage: '/analytics/alerts',
  analyticsApiKeysPage: '/analytics/api-keys',
};

export default pageUrls;
